import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Liberal: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#0a0a0a',
    color: '#222',
    fontFamily: "'Inter', Arial, Helvetica, sans-serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    <main style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }}>
      <div style={{
        maxWidth: 900,
        width: '100%',
        margin: '40px auto',
        background: '#fff',
        padding: 32,
        borderRadius: 8,
        boxSizing: 'border-box',
        boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
      }}>
        <div style={{
          color: '#0a3d62',
          fontWeight: 700,
          fontSize: '1.05em',
          letterSpacing: 1,
          marginBottom: 8
        }}>
          MATÉRIA ESPECIAL | COP 30 EM BELÉM
        </div>
        <h1 style={{ color: '#0a3d62', marginTop: 0, marginBottom: 8 }}>
          Diárias nas alturas, lixo nos córregos: o lucro tóxico da hotelaria durante a COP 30
        </h1>
        <div style={{ color: '#444', fontSize: '1em', marginBottom: 24 }}>
          Por Rafael Lima | Repórter Investigativo
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
          <img
            src="/images/logo/oliberal.jpg"
            alt="Belém COP 30"
            style={{
              width: '100%',
              maxWidth: 300,
              borderRadius: 8,
              margin: '20px 0'
            }}
          />
        </div>
        <p>
          Belém virou vitrine global da sustentabilidade com a chegada da COP 30. Mas por trás dos painéis solares e dos discursos sobre carbono neutro, há uma realidade que fede — literalmente.
        </p>
        <p>
          Enquanto líderes mundiais discutem o futuro do planeta, hotéis da capital paraense cobram diárias que ultrapassam R$ 9.500, transformando a cidade em um playground para executivos e diplomatas. Mas o luxo tem um rastro: rios contaminados, matas degradadas e lixo despejado ilegalmente em Aurá.
        </p>
        <h2 style={{ color: '#222', fontWeight: 600, marginBottom: 12, marginTop: 32 }}>
          Accor, Radisson e Bristol: o trio do luxo e do lixo
        </h2>
        <p>
          A reportagem apurou que redes como Accor, Radisson Hotel Group e Bristol estão entre as que mais lucram com a alta demanda de hospedagem durante o evento. Mas também estão entre as que contratam empresas como a Lev Descartes, responsável por recolher resíduos e despejá-los de forma irregular no antigo aterro do Aurá — desativado por crime ambiental e agora reativado sob pressão política.
        </p>
        <h2 style={{ color: '#222', fontWeight: 600, marginBottom: 12, marginTop: 32 }}>
          Greenwashing em tempo real
        </h2>
        <p>
          Muitos desses hotéis ostentam selos ambientais como o Green Key, padrão internacional de excelência ambiental no turismo. Mas o que se vê em Belém é um verdadeiro greenwashing institucional: relatórios bonitos, práticas sujas.
        </p>
        <h2 style={{ color: '#222', fontWeight: 600, marginBottom: 12, marginTop: 32 }}>
          O custo da COP 30 para quem não está nos salões
        </h2>
        <p>
          A COP 30 prometia colocar Belém no mapa da sustentabilidade. Mas, para quem vive perto do lixo, o evento virou sinônimo de abandono.
        </p>
        <p>
          Enquanto hotéis lucram com o turismo diplomático, a população paga com a saúde e o silêncio.
        </p>
        <div style={{
          background: '#eaf6fb',
          borderRadius: 6,
          padding: 18,
          margin: '32px 0',
          color: '#0a3d62',
          fontWeight: 500,
          fontSize: '1.1em'
        }}>
          Acompanhe nossa cobertura completa da COP 30 e os bastidores da crise ambiental em Belém. Porque o planeta não se salva com discurso — se salva com responsabilidade.
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', margin: '24px 0' }}>
          <video
            src="/files/visaoAuraVideo.mp4"
            controls
            style={{
              width: '100%',
              maxWidth: 700,
              borderRadius: 8,
              background: '#000'
            }}
          >
            Seu navegador não suporta a tag de vídeo.
          </video>
        </div>
        <div style={{
          color: '#888',
          fontSize: '0.95em',
          marginTop: 16,
          wordBreak: 'break-word'
        }}>
          #COP30 #Belém #Greenwashing #Accor #Radisson #Bristol #LixoDeLuxo #JustiçaAmbiental #AuráNãoÉLixão #SustentabilidadeDeFachada #RacismoAmbiental #MeioAmbiente #AmazôniaResiste
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default Liberal;